import React from "react";
import { Link } from "react-router-dom";

const ITEMS = [
  "AI Marketing",
  "SEO Optimalisatie",
  "Social Media Advertising",
  "Webdesign AI",
  "Webflow & WordPress",
  "Content Optimalisatie",
  "AI Optimalisatie (GEO)",
];

const Row = () => (
  <div className="marquee__track">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="px-8 font-display font-medium text-2xl sm:text-3xl lg:text-4xl text-coal/85 whitespace-nowrap tracking-tight">
          {t}
        </span>
        <span className="w-2.5 h-2.5 rounded-full bg-electric shrink-0" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    data-testid="marquee-section"
    className="relative bg-ivory border-y border-ivory-400 py-8 lg:py-10 overflow-hidden"
    aria-label="Onze diensten"
  >
    <div className="marquee" aria-hidden="true">
      <Row />
      <Row />
    </div>
    <Link
      to="/diensten"
      className="sr-only"
      data-testid="marquee-services-link"
    >
      Bekijk alle diensten
    </Link>
  </section>
);

export default Marquee;
